/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UserAdministrationUsersRouteImport } from './routes/user-administration/users'
import { Route as UserAdministrationArchiveRouteImport } from './routes/user-administration/archive'
import { Route as OutpatientArchiveRouteImport } from './routes/outpatient/archive'
import { Route as CustomerAdministrationUsersRouteImport } from './routes/customer-administration/users'
import { Route as CustomerAdministrationPatientsRouteImport } from './routes/customer-administration/patients'
import { Route as CustomerAdministrationIdnsRouteImport } from './routes/customer-administration/idns'
import { Route as CustomerAdministrationDepartmentsRouteImport } from './routes/customer-administration/departments'
import { Route as AbbottAdministrationUsersRouteImport } from './routes/abbott-administration/users'
import { Route as AbbottAdministrationArchiveRouteImport } from './routes/abbott-administration/archive'
import { Route as UserAdministrationDepartmentsIndexRouteImport } from './routes/user-administration/departments.index'
import { Route as OutpatientPatientsIndexRouteImport } from './routes/outpatient/patients.index'
import { Route as UserAdministrationDepartmentsDepartmentIdRouteImport } from './routes/user-administration/departments.$departmentId'
import { Route as OutpatientPatientsPatientIdRouteImport } from './routes/outpatient/patients.$patientId'
import { Route as CustomerAdministrationIdnsIdnIdRouteImport } from './routes/customer-administration/idns.$idnId'
import { Route as CustomerAdministrationDepartmentsDepartmentIdRouteImport } from './routes/customer-administration/departments.$departmentId'
import { Route as ActivationTokenLegalRouteImport } from './routes/activation/$token.legal'
import { Route as ActivationTokenAccountRouteImport } from './routes/activation/$token.account'
import { Route as AbbottAdministrationArchiveUserIdRouteImport } from './routes/abbott-administration/archive.$userId'
import { Route as UserAdministrationUsersProfileUserIdRouteImport } from './routes/user-administration/users.profile.$userId'
import { Route as CustomerAdministrationUsersProfileUserIdRouteImport } from './routes/customer-administration/users.profile.$userId'
import { Route as ActivationTokenUserIDAccountRouteImport } from './routes/activation/$token.$userID.account'
import { Route as AbbottAdministrationUsersProfileUserIdRouteImport } from './routes/abbott-administration/users.profile.$userId'

const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserAdministrationUsersRoute = UserAdministrationUsersRouteImport.update({
  id: '/user-administration/users',
  path: '/user-administration/users',
  getParentRoute: () => rootRouteImport,
} as any)
const UserAdministrationArchiveRoute =
  UserAdministrationArchiveRouteImport.update({
    id: '/user-administration/archive',
    path: '/user-administration/archive',
    getParentRoute: () => rootRouteImport,
  } as any)
const OutpatientArchiveRoute = OutpatientArchiveRouteImport.update({
  id: '/outpatient/archive',
  path: '/outpatient/archive',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerAdministrationUsersRoute =
  CustomerAdministrationUsersRouteImport.update({
    id: '/customer-administration/users',
    path: '/customer-administration/users',
    getParentRoute: () => rootRouteImport,
  } as any)
const CustomerAdministrationPatientsRoute =
  CustomerAdministrationPatientsRouteImport.update({
    id: '/customer-administration/patients',
    path: '/customer-administration/patients',
    getParentRoute: () => rootRouteImport,
  } as any)
const CustomerAdministrationIdnsRoute =
  CustomerAdministrationIdnsRouteImport.update({
    id: '/customer-administration/idns',
    path: '/customer-administration/idns',
    getParentRoute: () => rootRouteImport,
  } as any)
const CustomerAdministrationDepartmentsRoute =
  CustomerAdministrationDepartmentsRouteImport.update({
    id: '/customer-administration/departments',
    path: '/customer-administration/departments',
    getParentRoute: () => rootRouteImport,
  } as any)
const AbbottAdministrationUsersRoute =
  AbbottAdministrationUsersRouteImport.update({
    id: '/abbott-administration/users',
    path: '/abbott-administration/users',
    getParentRoute: () => rootRouteImport,
  } as any)
const AbbottAdministrationArchiveRoute =
  AbbottAdministrationArchiveRouteImport.update({
    id: '/abbott-administration/archive',
    path: '/abbott-administration/archive',
    getParentRoute: () => rootRouteImport,
  } as any)
const UserAdministrationDepartmentsIndexRoute =
  UserAdministrationDepartmentsIndexRouteImport.update({
    id: '/user-administration/departments/',
    path: '/user-administration/departments/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OutpatientPatientsIndexRoute = OutpatientPatientsIndexRouteImport.update({
  id: '/outpatient/patients/',
  path: '/outpatient/patients/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserAdministrationDepartmentsDepartmentIdRoute =
  UserAdministrationDepartmentsDepartmentIdRouteImport.update({
    id: '/user-administration/departments/$departmentId',
    path: '/user-administration/departments/$departmentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OutpatientPatientsPatientIdRoute =
  OutpatientPatientsPatientIdRouteImport.update({
    id: '/outpatient/patients/$patientId',
    path: '/outpatient/patients/$patientId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CustomerAdministrationIdnsIdnIdRoute =
  CustomerAdministrationIdnsIdnIdRouteImport.update({
    id: '/$idnId',
    path: '/$idnId',
    getParentRoute: () => CustomerAdministrationIdnsRoute,
  } as any)
const CustomerAdministrationDepartmentsDepartmentIdRoute =
  CustomerAdministrationDepartmentsDepartmentIdRouteImport.update({
    id: '/$departmentId',
    path: '/$departmentId',
    getParentRoute: () => CustomerAdministrationDepartmentsRoute,
  } as any)
const ActivationTokenLegalRoute = ActivationTokenLegalRouteImport.update({
  id: '/activation/$token/legal',
  path: '/activation/$token/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivationTokenAccountRoute = ActivationTokenAccountRouteImport.update({
  id: '/activation/$token/account',
  path: '/activation/$token/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AbbottAdministrationArchiveUserIdRoute =
  AbbottAdministrationArchiveUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => AbbottAdministrationArchiveRoute,
  } as any)
const UserAdministrationUsersProfileUserIdRoute =
  UserAdministrationUsersProfileUserIdRouteImport.update({
    id: '/profile/$userId',
    path: '/profile/$userId',
    getParentRoute: () => UserAdministrationUsersRoute,
  } as any)
const CustomerAdministrationUsersProfileUserIdRoute =
  CustomerAdministrationUsersProfileUserIdRouteImport.update({
    id: '/profile/$userId',
    path: '/profile/$userId',
    getParentRoute: () => CustomerAdministrationUsersRoute,
  } as any)
const ActivationTokenUserIDAccountRoute =
  ActivationTokenUserIDAccountRouteImport.update({
    id: '/activation/$token/$userID/account',
    path: '/activation/$token/$userID/account',
    getParentRoute: () => rootRouteImport,
  } as any)
const AbbottAdministrationUsersProfileUserIdRoute =
  AbbottAdministrationUsersProfileUserIdRouteImport.update({
    id: '/profile/$userId',
    path: '/profile/$userId',
    getParentRoute: () => AbbottAdministrationUsersRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/support': typeof SupportRoute
  '/abbott-administration/archive': typeof AbbottAdministrationArchiveRouteWithChildren
  '/abbott-administration/users': typeof AbbottAdministrationUsersRouteWithChildren
  '/customer-administration/departments': typeof CustomerAdministrationDepartmentsRouteWithChildren
  '/customer-administration/idns': typeof CustomerAdministrationIdnsRouteWithChildren
  '/customer-administration/patients': typeof CustomerAdministrationPatientsRoute
  '/customer-administration/users': typeof CustomerAdministrationUsersRouteWithChildren
  '/outpatient/archive': typeof OutpatientArchiveRoute
  '/user-administration/archive': typeof UserAdministrationArchiveRoute
  '/user-administration/users': typeof UserAdministrationUsersRouteWithChildren
  '/abbott-administration/archive/$userId': typeof AbbottAdministrationArchiveUserIdRoute
  '/activation/$token/account': typeof ActivationTokenAccountRoute
  '/activation/$token/legal': typeof ActivationTokenLegalRoute
  '/customer-administration/departments/$departmentId': typeof CustomerAdministrationDepartmentsDepartmentIdRoute
  '/customer-administration/idns/$idnId': typeof CustomerAdministrationIdnsIdnIdRoute
  '/outpatient/patients/$patientId': typeof OutpatientPatientsPatientIdRoute
  '/user-administration/departments/$departmentId': typeof UserAdministrationDepartmentsDepartmentIdRoute
  '/outpatient/patients': typeof OutpatientPatientsIndexRoute
  '/user-administration/departments': typeof UserAdministrationDepartmentsIndexRoute
  '/abbott-administration/users/profile/$userId': typeof AbbottAdministrationUsersProfileUserIdRoute
  '/activation/$token/$userID/account': typeof ActivationTokenUserIDAccountRoute
  '/customer-administration/users/profile/$userId': typeof CustomerAdministrationUsersProfileUserIdRoute
  '/user-administration/users/profile/$userId': typeof UserAdministrationUsersProfileUserIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/support': typeof SupportRoute
  '/abbott-administration/archive': typeof AbbottAdministrationArchiveRouteWithChildren
  '/abbott-administration/users': typeof AbbottAdministrationUsersRouteWithChildren
  '/customer-administration/departments': typeof CustomerAdministrationDepartmentsRouteWithChildren
  '/customer-administration/idns': typeof CustomerAdministrationIdnsRouteWithChildren
  '/customer-administration/patients': typeof CustomerAdministrationPatientsRoute
  '/customer-administration/users': typeof CustomerAdministrationUsersRouteWithChildren
  '/outpatient/archive': typeof OutpatientArchiveRoute
  '/user-administration/archive': typeof UserAdministrationArchiveRoute
  '/user-administration/users': typeof UserAdministrationUsersRouteWithChildren
  '/abbott-administration/archive/$userId': typeof AbbottAdministrationArchiveUserIdRoute
  '/activation/$token/account': typeof ActivationTokenAccountRoute
  '/activation/$token/legal': typeof ActivationTokenLegalRoute
  '/customer-administration/departments/$departmentId': typeof CustomerAdministrationDepartmentsDepartmentIdRoute
  '/customer-administration/idns/$idnId': typeof CustomerAdministrationIdnsIdnIdRoute
  '/outpatient/patients/$patientId': typeof OutpatientPatientsPatientIdRoute
  '/user-administration/departments/$departmentId': typeof UserAdministrationDepartmentsDepartmentIdRoute
  '/outpatient/patients': typeof OutpatientPatientsIndexRoute
  '/user-administration/departments': typeof UserAdministrationDepartmentsIndexRoute
  '/abbott-administration/users/profile/$userId': typeof AbbottAdministrationUsersProfileUserIdRoute
  '/activation/$token/$userID/account': typeof ActivationTokenUserIDAccountRoute
  '/customer-administration/users/profile/$userId': typeof CustomerAdministrationUsersProfileUserIdRoute
  '/user-administration/users/profile/$userId': typeof UserAdministrationUsersProfileUserIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/support': typeof SupportRoute
  '/abbott-administration/archive': typeof AbbottAdministrationArchiveRouteWithChildren
  '/abbott-administration/users': typeof AbbottAdministrationUsersRouteWithChildren
  '/customer-administration/departments': typeof CustomerAdministrationDepartmentsRouteWithChildren
  '/customer-administration/idns': typeof CustomerAdministrationIdnsRouteWithChildren
  '/customer-administration/patients': typeof CustomerAdministrationPatientsRoute
  '/customer-administration/users': typeof CustomerAdministrationUsersRouteWithChildren
  '/outpatient/archive': typeof OutpatientArchiveRoute
  '/user-administration/archive': typeof UserAdministrationArchiveRoute
  '/user-administration/users': typeof UserAdministrationUsersRouteWithChildren
  '/abbott-administration/archive/$userId': typeof AbbottAdministrationArchiveUserIdRoute
  '/activation/$token/account': typeof ActivationTokenAccountRoute
  '/activation/$token/legal': typeof ActivationTokenLegalRoute
  '/customer-administration/departments/$departmentId': typeof CustomerAdministrationDepartmentsDepartmentIdRoute
  '/customer-administration/idns/$idnId': typeof CustomerAdministrationIdnsIdnIdRoute
  '/outpatient/patients/$patientId': typeof OutpatientPatientsPatientIdRoute
  '/user-administration/departments/$departmentId': typeof UserAdministrationDepartmentsDepartmentIdRoute
  '/outpatient/patients/': typeof OutpatientPatientsIndexRoute
  '/user-administration/departments/': typeof UserAdministrationDepartmentsIndexRoute
  '/abbott-administration/users/profile/$userId': typeof AbbottAdministrationUsersProfileUserIdRoute
  '/activation/$token/$userID/account': typeof ActivationTokenUserIDAccountRoute
  '/customer-administration/users/profile/$userId': typeof CustomerAdministrationUsersProfileUserIdRoute
  '/user-administration/users/profile/$userId': typeof UserAdministrationUsersProfileUserIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/support'
    | '/abbott-administration/archive'
    | '/abbott-administration/users'
    | '/customer-administration/departments'
    | '/customer-administration/idns'
    | '/customer-administration/patients'
    | '/customer-administration/users'
    | '/outpatient/archive'
    | '/user-administration/archive'
    | '/user-administration/users'
    | '/abbott-administration/archive/$userId'
    | '/activation/$token/account'
    | '/activation/$token/legal'
    | '/customer-administration/departments/$departmentId'
    | '/customer-administration/idns/$idnId'
    | '/outpatient/patients/$patientId'
    | '/user-administration/departments/$departmentId'
    | '/outpatient/patients'
    | '/user-administration/departments'
    | '/abbott-administration/users/profile/$userId'
    | '/activation/$token/$userID/account'
    | '/customer-administration/users/profile/$userId'
    | '/user-administration/users/profile/$userId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/signup'
    | '/support'
    | '/abbott-administration/archive'
    | '/abbott-administration/users'
    | '/customer-administration/departments'
    | '/customer-administration/idns'
    | '/customer-administration/patients'
    | '/customer-administration/users'
    | '/outpatient/archive'
    | '/user-administration/archive'
    | '/user-administration/users'
    | '/abbott-administration/archive/$userId'
    | '/activation/$token/account'
    | '/activation/$token/legal'
    | '/customer-administration/departments/$departmentId'
    | '/customer-administration/idns/$idnId'
    | '/outpatient/patients/$patientId'
    | '/user-administration/departments/$departmentId'
    | '/outpatient/patients'
    | '/user-administration/departments'
    | '/abbott-administration/users/profile/$userId'
    | '/activation/$token/$userID/account'
    | '/customer-administration/users/profile/$userId'
    | '/user-administration/users/profile/$userId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/signup'
    | '/support'
    | '/abbott-administration/archive'
    | '/abbott-administration/users'
    | '/customer-administration/departments'
    | '/customer-administration/idns'
    | '/customer-administration/patients'
    | '/customer-administration/users'
    | '/outpatient/archive'
    | '/user-administration/archive'
    | '/user-administration/users'
    | '/abbott-administration/archive/$userId'
    | '/activation/$token/account'
    | '/activation/$token/legal'
    | '/customer-administration/departments/$departmentId'
    | '/customer-administration/idns/$idnId'
    | '/outpatient/patients/$patientId'
    | '/user-administration/departments/$departmentId'
    | '/outpatient/patients/'
    | '/user-administration/departments/'
    | '/abbott-administration/users/profile/$userId'
    | '/activation/$token/$userID/account'
    | '/customer-administration/users/profile/$userId'
    | '/user-administration/users/profile/$userId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  SupportRoute: typeof SupportRoute
  AbbottAdministrationArchiveRoute: typeof AbbottAdministrationArchiveRouteWithChildren
  AbbottAdministrationUsersRoute: typeof AbbottAdministrationUsersRouteWithChildren
  CustomerAdministrationDepartmentsRoute: typeof CustomerAdministrationDepartmentsRouteWithChildren
  CustomerAdministrationIdnsRoute: typeof CustomerAdministrationIdnsRouteWithChildren
  CustomerAdministrationPatientsRoute: typeof CustomerAdministrationPatientsRoute
  CustomerAdministrationUsersRoute: typeof CustomerAdministrationUsersRouteWithChildren
  OutpatientArchiveRoute: typeof OutpatientArchiveRoute
  UserAdministrationArchiveRoute: typeof UserAdministrationArchiveRoute
  UserAdministrationUsersRoute: typeof UserAdministrationUsersRouteWithChildren
  ActivationTokenAccountRoute: typeof ActivationTokenAccountRoute
  ActivationTokenLegalRoute: typeof ActivationTokenLegalRoute
  OutpatientPatientsPatientIdRoute: typeof OutpatientPatientsPatientIdRoute
  UserAdministrationDepartmentsDepartmentIdRoute: typeof UserAdministrationDepartmentsDepartmentIdRoute
  OutpatientPatientsIndexRoute: typeof OutpatientPatientsIndexRoute
  UserAdministrationDepartmentsIndexRoute: typeof UserAdministrationDepartmentsIndexRoute
  ActivationTokenUserIDAccountRoute: typeof ActivationTokenUserIDAccountRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-administration/users': {
      id: '/user-administration/users'
      path: '/user-administration/users'
      fullPath: '/user-administration/users'
      preLoaderRoute: typeof UserAdministrationUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-administration/archive': {
      id: '/user-administration/archive'
      path: '/user-administration/archive'
      fullPath: '/user-administration/archive'
      preLoaderRoute: typeof UserAdministrationArchiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/outpatient/archive': {
      id: '/outpatient/archive'
      path: '/outpatient/archive'
      fullPath: '/outpatient/archive'
      preLoaderRoute: typeof OutpatientArchiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-administration/users': {
      id: '/customer-administration/users'
      path: '/customer-administration/users'
      fullPath: '/customer-administration/users'
      preLoaderRoute: typeof CustomerAdministrationUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-administration/patients': {
      id: '/customer-administration/patients'
      path: '/customer-administration/patients'
      fullPath: '/customer-administration/patients'
      preLoaderRoute: typeof CustomerAdministrationPatientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-administration/idns': {
      id: '/customer-administration/idns'
      path: '/customer-administration/idns'
      fullPath: '/customer-administration/idns'
      preLoaderRoute: typeof CustomerAdministrationIdnsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-administration/departments': {
      id: '/customer-administration/departments'
      path: '/customer-administration/departments'
      fullPath: '/customer-administration/departments'
      preLoaderRoute: typeof CustomerAdministrationDepartmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/abbott-administration/users': {
      id: '/abbott-administration/users'
      path: '/abbott-administration/users'
      fullPath: '/abbott-administration/users'
      preLoaderRoute: typeof AbbottAdministrationUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/abbott-administration/archive': {
      id: '/abbott-administration/archive'
      path: '/abbott-administration/archive'
      fullPath: '/abbott-administration/archive'
      preLoaderRoute: typeof AbbottAdministrationArchiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-administration/departments/': {
      id: '/user-administration/departments/'
      path: '/user-administration/departments'
      fullPath: '/user-administration/departments'
      preLoaderRoute: typeof UserAdministrationDepartmentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/outpatient/patients/': {
      id: '/outpatient/patients/'
      path: '/outpatient/patients'
      fullPath: '/outpatient/patients'
      preLoaderRoute: typeof OutpatientPatientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-administration/departments/$departmentId': {
      id: '/user-administration/departments/$departmentId'
      path: '/user-administration/departments/$departmentId'
      fullPath: '/user-administration/departments/$departmentId'
      preLoaderRoute: typeof UserAdministrationDepartmentsDepartmentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/outpatient/patients/$patientId': {
      id: '/outpatient/patients/$patientId'
      path: '/outpatient/patients/$patientId'
      fullPath: '/outpatient/patients/$patientId'
      preLoaderRoute: typeof OutpatientPatientsPatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-administration/idns/$idnId': {
      id: '/customer-administration/idns/$idnId'
      path: '/$idnId'
      fullPath: '/customer-administration/idns/$idnId'
      preLoaderRoute: typeof CustomerAdministrationIdnsIdnIdRouteImport
      parentRoute: typeof CustomerAdministrationIdnsRoute
    }
    '/customer-administration/departments/$departmentId': {
      id: '/customer-administration/departments/$departmentId'
      path: '/$departmentId'
      fullPath: '/customer-administration/departments/$departmentId'
      preLoaderRoute: typeof CustomerAdministrationDepartmentsDepartmentIdRouteImport
      parentRoute: typeof CustomerAdministrationDepartmentsRoute
    }
    '/activation/$token/legal': {
      id: '/activation/$token/legal'
      path: '/activation/$token/legal'
      fullPath: '/activation/$token/legal'
      preLoaderRoute: typeof ActivationTokenLegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activation/$token/account': {
      id: '/activation/$token/account'
      path: '/activation/$token/account'
      fullPath: '/activation/$token/account'
      preLoaderRoute: typeof ActivationTokenAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/abbott-administration/archive/$userId': {
      id: '/abbott-administration/archive/$userId'
      path: '/$userId'
      fullPath: '/abbott-administration/archive/$userId'
      preLoaderRoute: typeof AbbottAdministrationArchiveUserIdRouteImport
      parentRoute: typeof AbbottAdministrationArchiveRoute
    }
    '/user-administration/users/profile/$userId': {
      id: '/user-administration/users/profile/$userId'
      path: '/profile/$userId'
      fullPath: '/user-administration/users/profile/$userId'
      preLoaderRoute: typeof UserAdministrationUsersProfileUserIdRouteImport
      parentRoute: typeof UserAdministrationUsersRoute
    }
    '/customer-administration/users/profile/$userId': {
      id: '/customer-administration/users/profile/$userId'
      path: '/profile/$userId'
      fullPath: '/customer-administration/users/profile/$userId'
      preLoaderRoute: typeof CustomerAdministrationUsersProfileUserIdRouteImport
      parentRoute: typeof CustomerAdministrationUsersRoute
    }
    '/activation/$token/$userID/account': {
      id: '/activation/$token/$userID/account'
      path: '/activation/$token/$userID/account'
      fullPath: '/activation/$token/$userID/account'
      preLoaderRoute: typeof ActivationTokenUserIDAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/abbott-administration/users/profile/$userId': {
      id: '/abbott-administration/users/profile/$userId'
      path: '/profile/$userId'
      fullPath: '/abbott-administration/users/profile/$userId'
      preLoaderRoute: typeof AbbottAdministrationUsersProfileUserIdRouteImport
      parentRoute: typeof AbbottAdministrationUsersRoute
    }
  }
}

interface AbbottAdministrationArchiveRouteChildren {
  AbbottAdministrationArchiveUserIdRoute: typeof AbbottAdministrationArchiveUserIdRoute
}

const AbbottAdministrationArchiveRouteChildren: AbbottAdministrationArchiveRouteChildren =
  {
    AbbottAdministrationArchiveUserIdRoute:
      AbbottAdministrationArchiveUserIdRoute,
  }

const AbbottAdministrationArchiveRouteWithChildren =
  AbbottAdministrationArchiveRoute._addFileChildren(
    AbbottAdministrationArchiveRouteChildren,
  )

interface AbbottAdministrationUsersRouteChildren {
  AbbottAdministrationUsersProfileUserIdRoute: typeof AbbottAdministrationUsersProfileUserIdRoute
}

const AbbottAdministrationUsersRouteChildren: AbbottAdministrationUsersRouteChildren =
  {
    AbbottAdministrationUsersProfileUserIdRoute:
      AbbottAdministrationUsersProfileUserIdRoute,
  }

const AbbottAdministrationUsersRouteWithChildren =
  AbbottAdministrationUsersRoute._addFileChildren(
    AbbottAdministrationUsersRouteChildren,
  )

interface CustomerAdministrationDepartmentsRouteChildren {
  CustomerAdministrationDepartmentsDepartmentIdRoute: typeof CustomerAdministrationDepartmentsDepartmentIdRoute
}

const CustomerAdministrationDepartmentsRouteChildren: CustomerAdministrationDepartmentsRouteChildren =
  {
    CustomerAdministrationDepartmentsDepartmentIdRoute:
      CustomerAdministrationDepartmentsDepartmentIdRoute,
  }

const CustomerAdministrationDepartmentsRouteWithChildren =
  CustomerAdministrationDepartmentsRoute._addFileChildren(
    CustomerAdministrationDepartmentsRouteChildren,
  )

interface CustomerAdministrationIdnsRouteChildren {
  CustomerAdministrationIdnsIdnIdRoute: typeof CustomerAdministrationIdnsIdnIdRoute
}

const CustomerAdministrationIdnsRouteChildren: CustomerAdministrationIdnsRouteChildren =
  {
    CustomerAdministrationIdnsIdnIdRoute: CustomerAdministrationIdnsIdnIdRoute,
  }

const CustomerAdministrationIdnsRouteWithChildren =
  CustomerAdministrationIdnsRoute._addFileChildren(
    CustomerAdministrationIdnsRouteChildren,
  )

interface CustomerAdministrationUsersRouteChildren {
  CustomerAdministrationUsersProfileUserIdRoute: typeof CustomerAdministrationUsersProfileUserIdRoute
}

const CustomerAdministrationUsersRouteChildren: CustomerAdministrationUsersRouteChildren =
  {
    CustomerAdministrationUsersProfileUserIdRoute:
      CustomerAdministrationUsersProfileUserIdRoute,
  }

const CustomerAdministrationUsersRouteWithChildren =
  CustomerAdministrationUsersRoute._addFileChildren(
    CustomerAdministrationUsersRouteChildren,
  )

interface UserAdministrationUsersRouteChildren {
  UserAdministrationUsersProfileUserIdRoute: typeof UserAdministrationUsersProfileUserIdRoute
}

const UserAdministrationUsersRouteChildren: UserAdministrationUsersRouteChildren =
  {
    UserAdministrationUsersProfileUserIdRoute:
      UserAdministrationUsersProfileUserIdRoute,
  }

const UserAdministrationUsersRouteWithChildren =
  UserAdministrationUsersRoute._addFileChildren(
    UserAdministrationUsersRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  SupportRoute: SupportRoute,
  AbbottAdministrationArchiveRoute:
    AbbottAdministrationArchiveRouteWithChildren,
  AbbottAdministrationUsersRoute: AbbottAdministrationUsersRouteWithChildren,
  CustomerAdministrationDepartmentsRoute:
    CustomerAdministrationDepartmentsRouteWithChildren,
  CustomerAdministrationIdnsRoute: CustomerAdministrationIdnsRouteWithChildren,
  CustomerAdministrationPatientsRoute: CustomerAdministrationPatientsRoute,
  CustomerAdministrationUsersRoute:
    CustomerAdministrationUsersRouteWithChildren,
  OutpatientArchiveRoute: OutpatientArchiveRoute,
  UserAdministrationArchiveRoute: UserAdministrationArchiveRoute,
  UserAdministrationUsersRoute: UserAdministrationUsersRouteWithChildren,
  ActivationTokenAccountRoute: ActivationTokenAccountRoute,
  ActivationTokenLegalRoute: ActivationTokenLegalRoute,
  OutpatientPatientsPatientIdRoute: OutpatientPatientsPatientIdRoute,
  UserAdministrationDepartmentsDepartmentIdRoute:
    UserAdministrationDepartmentsDepartmentIdRoute,
  OutpatientPatientsIndexRoute: OutpatientPatientsIndexRoute,
  UserAdministrationDepartmentsIndexRoute:
    UserAdministrationDepartmentsIndexRoute,
  ActivationTokenUserIDAccountRoute: ActivationTokenUserIDAccountRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
